type Props = {
  name: string;
  title: string;
  image: string;
  quote: string;
};

const QuoteMark = () => (
  <svg width="48" height="36" viewBox="0 0 48 36" fill="#333" aria-hidden="true" className="flex-shrink-0 w-[34px] lg:w-[48px]">
    <path d="M0 4a4 4 0 0 1 4-4h14a4 4 0 0 1 4 4v14c0 9-5 15.5-12.5 18L7 32c4-2 6-5.5 6.2-10H4a4 4 0 0 1-4-4V4Z" />
    <path d="M26 4a4 4 0 0 1 4-4h14a4 4 0 0 1 4 4v14c0 9-5 15.5-12.5 18L33 32c4-2 6-5.5 6.2-10H30a4 4 0 0 1-4-4V4Z" />
  </svg>
);

export const TestimonialCard = ({ name, title, image, quote }: Props) => {
  return (
    <div className="h-full rounded-[24px] lg:rounded-[32px] border-[3px] border-white bg-[#F6EFEE] shadow-[0_6px_30px_rgba(0,0,0,0.06)] px-[20px] py-6 lg:px-6 lg:pt-5 lg:pb-9 text-left">
      <div className="flex items-center gap-[16px] lg:gap-6">
        <img src={image} alt={name} className="w-[56px] h-[56px] lg:w-[78px] lg:h-[78px] rounded-full object-cover" />
        <div>
          <div className="text-[#171717] text-[17px] lg:text-[22px] font-medium">{name}</div>
          <div className="text-[#6B6B6B] text-[13px] lg:text-[17px]">{title}</div>
        </div>
      </div>
      <div className="mt-[20px] lg:mt-7 pl-[8px] lg:pl-10">
        <QuoteMark />
      </div>
      <p className="mt-[12px] lg:mt-4 lg:pl-[100px] text-[#222] text-[15px] lg:text-[22px] leading-[1.45]">“{quote}”</p>
    </div>
  );
};
